import * as React from "react";
import * as ReactDOM from "react-dom";
import "./rating.scss";
import { Rating } from "@progress/kendo-react-inputs";

// interface to declare all our prop types
interface Props {
    label?: string;
    defaultValue?: number;
    onChange?: any;
    disabled?: any;
    classname?:any;
    value?: any;
  }

const StarRating:  React.FC<Props> = ({ 
label,
defaultValue,
onChange,
disabled,
classname,
value,
}) => {
    return (
      <div className={"starRatingWrap " +classname }>
          <h4>{label}</h4>
          <Rating defaultValue={defaultValue} value={value} onChange={(e) => onChange(e)} disabled={disabled}/>
      </div>
    );
  }

  export default StarRating


